module.exports = __webpack_public_path__ + "static/media/maximize_filled.d15c2209.svg";